/** @format */

import { Box, Typography } from '@mui/material';

interface Props {
  header: string;
  value: any;
}
export default function DisplayFieldData({ header, value }: Props) {
  return (
    <Box mt={1.5}>
      <Typography sx={{ fontWeight: 'bold' }} className='profile__headers'>
        {header}
      </Typography>
      <Box>{value ? value : 'Not Specified'}</Box>
    </Box>
  );
}
